/** Кастомная версия Antd.FormList, в котором все поля FormList делятся на группы и правила
 * правило - единичный набор значений, группа - набор этих правил.
 * При этом любая группа и правило имеет логический предикат - И или ИЛИ.
 * Данная форма используется при составлении правил доступов и филтьтрации
 * (например, отображаем поле, если по правилу1 значение в столбце А равно 35 И(ИЛИ)
 * по правилу2 значение столбца Б не пустое
 * --
 * (использование подобной формы моджно найти в правилах настройки фильтрации ДД, а также в
 * настройках ограничений для ДД, обе в конфигураторе шаблонов отчетов, во вкладке настроек правил связи (ДД))
 */

// todo: перенести форму из report-dd-restriction + report-dd-filters
export const PredicateExpressionFormList = () => null;
